import React from 'react';
import { Mail, CreditCard } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-teal-600 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">WEALTHY FAITH</h3>
            <p className="text-white/80 leading-relaxed mb-4">
              Empowering individuals to build sustainable income through faith-based financial strategies.
            </p>
            <div className="flex items-center gap-2 text-white/80">
              <Mail className="w-5 h-5" />
              <a href="mailto:support@wealthyfaith.shop" className="hover:text-white transition-colors">
                support@wealthyfaith.shop
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-white/80 hover:text-white transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="text-white/80 hover:text-white transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#features" className="text-white/80 hover:text-white transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white/80 hover:text-white transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Payment Methods */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Secure Payment</h4>
            <p className="text-white/80 mb-4">
              We accept secure payments through PayKings
            </p>
            <div className="flex items-center gap-4">
              <div className="bg-white/10 rounded-lg px-4 py-2 flex items-center gap-2">
                <CreditCard className="w-6 h-6" />
                <span className="font-medium">PayKings</span>
              </div>
            </div>
            <p className="text-white/60 text-sm mt-4">
              All transactions are encrypted and secure
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              © 2026 Wealthy Faith. All rights reserved.
            </p>
            <p className="text-white/60 text-sm">
              Built with faith and purpose
            </p>
          </div>
        </div>

        {/* Faith Message */}
        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <p className="text-white/80 text-base">
            To Jesus be the glory. Jesus Loves You. Please read Acts 2:38. Thank you!
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
